import { useEffect } from 'react'
import NavigationListener from './NavigationListner'
import { getUserInfo, LoginTypeEnum, UserTypeEnum } from '@app-store'
import { useAppDispatch } from '../../utils/agent.store'

const LoginAttempt: React.FC<{
  token?: string | null
  text: string
  idToken?: string | null
  refreshToken?: string | null
}> = ({
  token = null,
  text = 'loading',
  idToken = null,
  refreshToken = null,
}) => {
  const dispatch = useAppDispatch()

  function removeIdTokenFromURL() {
    const url = new URL(window.location.href)
    if (url?.hash) {
      window.history.replaceState({}, document.title, url.origin + url.pathname)
    }
  }

  useEffect(() => {
    if (token) {
      dispatch(
        getUserInfo({
          token: token,
          refreshToken: refreshToken,
          idToken: idToken,
          pkce_code_verifier: localStorage.getItem('pkce_code_verifier'),
          source: LoginTypeEnum.LOGIN,
          user_type: UserTypeEnum.AGENT,
        })
      )
    }
    removeIdTokenFromURL()
  }, [token])

  return (
    <div className="flex items-center justify-center min-h-screen bg-accent-100">
      <NavigationListener />
      <div className="flex flex-col items-center">
        <svg
          className="animate-spin h-10 w-10 text-secondary-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 1 0 16 0A8 8 0 0 0 4 12zm14 0a6 6 0 1 1-12 0 6 6 0 0 1 12 0z"
          />
        </svg>
        <h2 className="mt-4 text-sm font-semibold text-accent-700">{text}</h2>
      </div>
    </div>
  )
}

export default LoginAttempt
